<template>
<div class="ag CMS" v-if="loaded">
  <agile
    class="main"
    ref="main"
    :options="mainOpts"
    >
    <div class="slide" v-for="(slide, index) in slides.main" :key="index" :class="`slide--${index}`">
      <a :href="slide.url">
        <img :src="slide.image" />
        <div class="CarouselContent">
          <p>
            <b>{{ slide.title }}</b>
            {{ slide.teaser }}
          </p>
        </div>
      </a>
    </div>
  </agile>
</div>
</template>

<script>
import { VueAgile } from "vue-agile";
import { mapGetters } from "vuex";

export default {
  name: 'CMSCarousel',
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
    loaded: function () {
      return this.slides.main.length >= 1;
    }
  },
  data() {
    return {
      elements: this.$parent.elements,
      mainOpts: {
        dots: false,
        fade: true,
        navButtons: true,
        autoplay: true,
        autoplaySpeed: 7000
      },
      slides: {
        main: []
      }
    };
  },
 created() {
   this.elements.forEach( el => {
     if (el.status === "success") {
       this.slides.main.push(el);
     }
   });
  },
  components: {
    agile: VueAgile
  }
}
</script>

<style scoped>
.ag {
    font-family: 'Lato', sans-serif;
    font-weight: 300;
    margin: 0 auto;
    max-width: 100%;
    padding: 0px;
}
.ag a {
    text-decoration: none;
}
.main {
  margin-bottom: 5px;
}
.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
}
.agile__nav-button:hover {
  color: #888;
}
.slide {
  -webkit-box-align: center;
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: -webkit-box;
  display: flex;
  /*height: 400px;*/
  -webkit-box-pack: center;
  justify-content: center;
}
.slide img {
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
}
</style>
